/**
 * Padelit — règle d'affichage des promos dans les zones natives du thème
 * (panier / tiroir panier, recherche instantanée, méga-menu).
 * Fichier autonome : aucun fichier natif du thème n'est modifié.
 *
 * Même règle que le snippet pdlt-card-price : une remise n'est mise en avant
 * (prix rouge + prix barré) que si elle est strictement supérieure à X %
 * ET que le prix remisé est >= Y €. Sinon le prix barré est masqué.
 * Seuils lus sur la balise <script> (data-min-pct / data-min-price),
 * alimentés par les métachamps boutique pdlt.promo_min_pct / pdlt.promo_min_price.
 *
 * En cas d'échec (structure du thème modifiée par une mise à jour),
 * rien n'est masqué : l'affichage natif du thème reste en place.
 * Performance : pas de dépendance, observation limitée aux sections
 * du panier, de la recherche et du menu, quelques éléments traités par passage.
 */
(() => {
  const script = document.currentScript;
  const MIN_PCT = parseFloat(script?.dataset.minPct) || 20;
  const RATE = parseFloat(window.Shopify?.currency?.rate) || 1;
  const MIN_PRICE = (parseFloat(script?.dataset.minPrice) || 30) * RATE;

  const toNumber = (el) => {
    if (!el) return NaN;
    let text = '';
    el.childNodes.forEach((n) => {
      if (n.nodeType === 3) text += n.textContent;
      else if (n.nodeType === 1 && !n.classList.contains('visually-hidden')) text += n.textContent;
    });
    text = text.replace(/[^\d,.]/g, '');
    if (/,\d{1,2}$/.test(text)) text = text.replace(/\./g, '').replace(',', '.');
    else text = text.replace(/,/g, '');
    return parseFloat(text);
  };

  const isAttractive = (price, compare) =>
    compare > price && price >= MIN_PRICE && ((compare - price) / compare) * 100 > MIN_PCT;

  const mark = (box, price, compare) => {
    if (!(price > 0) || !(compare > 0)) return;
    const ok = isAttractive(price, compare);
    if (box.classList.contains(ok ? 'pdlt-promo' : 'pdlt-plain')) return;
    box.classList.toggle('pdlt-promo', ok);
    box.classList.toggle('pdlt-plain', !ok);
  };

  // Recherche instantanée + méga-menu : cartes « resource-card »
  const processResourceCards = (root) => {
    root.querySelectorAll('.resource-card [ref="priceContainer"]').forEach((box) => {
      const compare = box.querySelector('.compare-at-price');
      if (!compare) return;
      mark(box, toNumber(box.querySelector('.price')), toNumber(compare));
    });
  };

  // Panier et tiroir panier : prix unitaire (hors remise par code, laissée intacte)
  const processCart = (root) => {
    root.querySelectorAll('.cart-items__unit-price-wrapper > div').forEach((box) => {
      const compare = box.querySelector('s.compare-at-price');
      if (!compare) return;
      const row = box.closest('tr') || box.closest('.cart-items__table-row');
      if (row && row.querySelector('ul.list-unstyled[role="list"]')) return; // remise par code : on ne touche pas
      const priceEl = [...box.children].find(
        (e) => e.tagName === 'SPAN' && !e.classList.contains('visually-hidden')
      );
      mark(box, toNumber(priceEl), toNumber(compare));
    });
  };

  const run = (root) => {
    processResourceCards(root);
    processCart(root);
  };

  const TARGETS = 'cart-items-component, predictive-search-component, header-menu, header-drawer';
  const roots = new Set();
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(() => {
      scheduled = false;
      roots.forEach(run);
    });
  });

  const init = () => {
    document.querySelectorAll(TARGETS).forEach((el) => {
      const root = el.closest('.shopify-section') || el;
      if (roots.has(root)) return;
      roots.add(root);
      run(root);
      observer.observe(root, { childList: true, subtree: true });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
